import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import PurchaseCsvExportItem, {
  PurchaseCsvColumn
} from './PurchaseCsvExportItem'

// Mesmos cabeçalhos aceitos pela Carga de Férias (arquivo reimportável)
const COLUMNS: PurchaseCsvColumn[] = [
  { header: 'CompradorPrincipalEmail', field: 'compradorPrincipalEmail' },
  { header: 'CompradorFeriasEmail', field: 'compradorFeriasEmail' },
  { header: 'FornecedorId', field: 'fornecedorId' },
  { header: 'DataInicio', field: 'dataInicio' },
  { header: 'DataFim', field: 'dataFim' }
]

const ActionExcelPurchaseFeriasExport: FC = () => {
  const { dataFerias = [] } = useParametrizationConfigPurchase()

  const getRows = () =>
    dataFerias.map(ferias => ({
      compradorPrincipalEmail: ferias['comprador-principal-email'],
      compradorFeriasEmail: ferias['comprador-ferias-email'],
      fornecedorId:
        ferias['comprador-fornecedor-id'] ?? ferias['comprador-fornecedor'],
      dataInicio: ferias['user-de'],
      dataFim: ferias['user-ate']
    }))

  return (
    <PurchaseCsvExportItem
      filenamePrefix="ferias-compra"
      columns={COLUMNS}
      getRows={getRows}
      rowCount={dataFerias.length}
    />
  )
}

export default ActionExcelPurchaseFeriasExport
